module.exports = __webpack_public_path__ + "img/ATTRIBUTES.d68b6a50.svg";